import { CommonStore } from './modules/common/CommonStore'

import { RouterStore } from 'mobx-react-router'
import * as React from 'react'
import { inject } from 'mobx-react'
import { observable } from 'mobx'
import { StorydocStoreUI } from './modules/storydoc/storydocStoreUI'
import { StorydocStoreContent } from './modules/storydoc/storydocStoreContent'
import { AppStore } from './appStore'

export function createStore () {
  const routeStore = new RouterStore()
  const commonStore = new CommonStore()

  const breakpoints = observable({
    phone: '(max-width: 768px) , (max-height: 480px)',
    desktop: '(min-width: 769px) AND (min-height: 480px))'
  } as { phone: string | boolean, desktop: string | boolean })
  const store = {
    storeCommon: commonStore,
    storeRouter: routeStore,
    storyDocUI: new StorydocStoreUI(),
    storyDocContent: new StorydocStoreContent(commonStore),
    breakpoints: breakpoints,
    appStore: new AppStore()
  }
  return store
}

type Unpacked<T> =
  T extends (infer U)[] ? U :
  T extends (...args: any[]) => infer U ? U :
  T extends Promise<infer U> ? U :
  T

export type IStore = Unpacked<typeof createStore>

export const injectStores = inject((store: IStore) => {
  return {
    _allStores: store
  }
})

export class StoreComponent<IProps = {}, IState = {}, SS = any> extends React.Component<{ _allStores?: IStore } & IProps, IState, SS> {
  store: IStore

  constructor (props: { _allStores?: IStore } & IProps, context: any) {
    super(props, context)
    this.store = this.props._allStores!
  }
}



// WEBPACK FOOTER //
// ./src/store.ts